<script>
    import { Router, Route } from "svelte-routing";
    import Header from './components/header.svelte';
    import Footer from './components/footer.svelte';
    import Home from './pages/home/home.svelte';
    import Cspage from './pages/cspage/cspage.svelte';
    import Mathpage from './pages/mathpage/mathpage.svelte';
    import Sciencepage from './pages/sciencepage/sciencepage.svelte';
    import ContentDetail from './pages/ContentDetail.svelte';

    let initialPath = "/";
    if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        const pathParam = params.get("path");
        if (pathParam) {
            initialPath = decodeURIComponent(pathParam);
            window.history.replaceState(null, '', initialPath);
        }
    }
</script>

<Router url={initialPath}>
    <Header />
    <div class="content-wrapper">
        <Route path="/" component={Home} />
        <Route path="/cspage" component={Cspage} />
        <Route path="/mathpage" component={Mathpage} />
        <Route path="/sciencepage" component={Sciencepage} />
        <Route path="/content/:id" component={ContentDetail} />
    </div>
    <Footer />
</Router>